import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import SearchFilterRequest from '../../../Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest';
import UpdateSleepStoryRequest from '../../../Spirit/Admin/Interfaces/Models/SleepStoryService/UpdateSleepStoryRequest';
import GetSleepStoryCategoryCategoryRequest from '../../../Spirit/Admin/Interfaces/Models/SleepStoryService/GetSleepStoryCategoryCategoryRequest';
import UpdateSleepStoryCategoryRequest from '../../../Spirit/Admin/Interfaces/Models/SleepStoryService/UpdateSleepStoryCategoryRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import SleepStoryResponse from '../../../Spirit/Admin/Interfaces/Models/SleepStoryService/SleepStoryResponse';
import SleepStoryDetailResponse from '../../../Spirit/Admin/Interfaces/Models/SleepStoryService/SleepStoryDetailResponse';
import SleepStoryCategoryCategoryResponse from '../../../Spirit/Admin/Interfaces/Models/SleepStoryService/SleepStoryCategoryCategoryResponse';

export default class SleepStoryService {
	webApiService: WebApiService;
	DeleteSleepStoryEvent = new Events<WsResponseModelT<Boolean>>();
	GetSleepStoriesEvent = new Events<WsResponseModelT<PaginationResponseT<SleepStoryResponse>>>();
	GetSleepStoryEvent = new Events<WsResponseModelT<SleepStoryDetailResponse>>();
	ToggleIsPaidEvent = new Events<WsResponseModelT<Boolean>>();
	ToggleUseBackgroundMusicEvent = new Events<WsResponseModelT<Boolean>>();
	ToggleUseOnMainDisplayEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateSleepStoryEvent = new Events<WsResponseModelT<Boolean>>();
	GetCategoriesEvent = new Events<WsResponseModelT<PaginationResponseT<SleepStoryCategoryCategoryResponse>>>();
	GetCategoryEvent = new Events<WsResponseModelT<SleepStoryCategoryCategoryResponse>>();
	UpdateCategoryEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteCategoryEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('SleepStoryService', 'DeleteSleepStory', (res: WsResponseModelT<Boolean>) => {
			self.DeleteSleepStoryEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'GetSleepStories', (res: WsResponseModelT<PaginationResponseT<SleepStoryResponse>>) => {
			self.GetSleepStoriesEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'GetSleepStory', (res: WsResponseModelT<SleepStoryDetailResponse>) => {
			self.GetSleepStoryEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'ToggleIsPaid', (res: WsResponseModelT<Boolean>) => {
			self.ToggleIsPaidEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'ToggleUseBackgroundMusic', (res: WsResponseModelT<Boolean>) => {
			self.ToggleUseBackgroundMusicEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'ToggleUseOnMainDisplay', (res: WsResponseModelT<Boolean>) => {
			self.ToggleUseOnMainDisplayEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'UpdateSleepStory', (res: WsResponseModelT<Boolean>) => {
			self.UpdateSleepStoryEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'GetCategories', (res: WsResponseModelT<PaginationResponseT<SleepStoryCategoryCategoryResponse>>) => {
			self.GetCategoriesEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'GetCategory', (res: WsResponseModelT<SleepStoryCategoryCategoryResponse>) => {
			self.GetCategoryEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'UpdateCategory', (res: WsResponseModelT<Boolean>) => {
			self.UpdateCategoryEvent.trigger(res);
		});
		webApiService.on('SleepStoryService', 'DeleteCategory', (res: WsResponseModelT<Boolean>) => {
			self.DeleteCategoryEvent.trigger(res);
		});
	}
	DeleteSleepStory(id: number = 0) { 	
        this.webApiService.send('SleepStoryService', 'DeleteSleepStory' , id);
    }
	GetSleepStories(request: SearchFilterRequest = null) { 	
        this.webApiService.send('SleepStoryService', 'GetSleepStories' , request);
    }
	GetSleepStory(id: number = 0) { 	
        this.webApiService.send('SleepStoryService', 'GetSleepStory' , id);
    }
	ToggleIsPaid(id: number = 0) { 	
        this.webApiService.send('SleepStoryService', 'ToggleIsPaid' , id);
    }
	ToggleUseBackgroundMusic(id: number = 0) { 	
        this.webApiService.send('SleepStoryService', 'ToggleUseBackgroundMusic' , id);
    }
	ToggleUseOnMainDisplay(id: number = 0) { 	
        this.webApiService.send('SleepStoryService', 'ToggleUseOnMainDisplay' , id);
    }
	UpdateSleepStory(request: UpdateSleepStoryRequest = null) { 	
        this.webApiService.send('SleepStoryService', 'UpdateSleepStory' , request);
    }
	GetCategories(request: GetSleepStoryCategoryCategoryRequest = null) { 	
        this.webApiService.send('SleepStoryService', 'GetCategories' , request);
    }
	GetCategory(id: number = 0) { 	
        this.webApiService.send('SleepStoryService', 'GetCategory' , id);
    }
	UpdateCategory(request: UpdateSleepStoryCategoryRequest = null) { 	
        this.webApiService.send('SleepStoryService', 'UpdateCategory' , request);
    }
	DeleteCategory(id: number = 0) { 	
        this.webApiService.send('SleepStoryService', 'DeleteCategory' , id);
    }
	 // async methods
	async deleteSleepStoryAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteSleepStory.bind(this), this.DeleteSleepStoryEvent)(id);
	}
	async getSleepStoriesAsync(request: SearchFilterRequest = null): Promise<PaginationResponseT<SleepStoryResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetSleepStories.bind(this), this.GetSleepStoriesEvent)(request);
	}
	async getSleepStoryAsync(id: number = 0): Promise<SleepStoryDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetSleepStory.bind(this), this.GetSleepStoryEvent)(id);
	}
	async toggleIsPaidAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleIsPaid.bind(this), this.ToggleIsPaidEvent)(id);
	}
	async toggleUseBackgroundMusicAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleUseBackgroundMusic.bind(this), this.ToggleUseBackgroundMusicEvent)(id);
	}
	async toggleUseOnMainDisplayAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleUseOnMainDisplay.bind(this), this.ToggleUseOnMainDisplayEvent)(id);
	}
	async updateSleepStoryAsync(request: UpdateSleepStoryRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateSleepStory.bind(this), this.UpdateSleepStoryEvent)(request);
	}
	async getCategoriesAsync(request: GetSleepStoryCategoryCategoryRequest = null): Promise<PaginationResponseT<SleepStoryCategoryCategoryResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetCategories.bind(this), this.GetCategoriesEvent)(request);
	}
	async getCategoryAsync(id: number = 0): Promise<SleepStoryCategoryCategoryResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetCategory.bind(this), this.GetCategoryEvent)(id);
	}
	async updateCategoryAsync(request: UpdateSleepStoryCategoryRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateCategory.bind(this), this.UpdateCategoryEvent)(request);
	}
	async deleteCategoryAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteCategory.bind(this), this.DeleteCategoryEvent)(id);
	}
}